import { render } from "./AuthenticateMain.vue?vue&type=template&id=d854da72"
import script from "./AuthenticateMain.vue?vue&type=script&lang=js"
export * from "./AuthenticateMain.vue?vue&type=script&lang=js"
script.render = render

export default script